/* eslint-disable */
// ref: https://developers.google.com/recaptcha/docs/v3
// ref: https://gist.github.com/aellerton/92f33cef04a1df76636a658571e07724
// ref: https://gist.github.com/hypeJunction/05ddb40d38da4e107ea73b097656d1d2

// CHANGELOG: add recaptcha v2 and fallback localhost key, please check Login.vue page to see how to use

let siteKey   = process.env.VUE_APP_GOOGLE_RECAPTCHA_ENTERPRISE_KEY;
let checkboxFallbackSiteKey   = process.env.VUE_APP_GOOGLE_RECAPTCHA_ENTERPRISE_CHECKBOX_KEY;

const devSecretKey = '6LcxBcUUAAAAANqApCLSDVH92JW_6Hv4D00Q90Jl';

// https://developers.google.com/recaptcha/docs/faq
const devSecretKeyV2 = '6LeIxAcTAAAAAGG-vFI1TnRWxMZNFuojJ4WifJWe';

// if (process.env.VUE_APP_ENV === 'development') {
//   siteKey = devSiteKey;
//   siteKeyV2 = devSiteKeyV2;
// }

/**
 * input ME site i18n.locale convert to google lang code
 * @param {String} lang default='en'
 */
function convertLang(lang = 'en') {
  switch (lang) {
    case 'zh-hant':
      return 'zh-TW';
    case 'zh-hans':
      return 'zh-CN';
    case 'es':
      return 'es-419';
    default:
      return lang;
  }
}

/**
 * load Google reCaptcha v3 and return key
 * @param {String} lang ME site store lang code
 * @param {Boolean} isCallback default no fallback
 */
export function load(lang, isCallback = false) {
  const head = document.head || document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/enterprise.js?hl=${convertLang(lang)}&render=${siteKey}${isCallback ? '&onload=onloadCallback' : ''}`
  script.async = true;
  script.defer = true;
  head.appendChild(script);
}

/**
 * load Google reCaptcha v2 and render to element
 * callback {Object} expiredCallback, errorCallback
 */
export function renderV2(callback) {
  // window.grecaptcha.reset();
  window.grecaptcha.enterprise.render('g-recaptchav2', {
    'sitekey' : checkboxFallbackSiteKey,
    'expired-callback': callback.expiredCallback,
    'error-callback': callback.errorCallback,
  });
}

export function renderCheckbox(callback) {
  // window.grecaptcha.reset();
  window.grecaptcha.enterprise.render('g-recaptchav2', {
    'sitekey' : checkboxFallbackSiteKey,
    'expired-callback': callback.expiredCallback,
    'error-callback': callback.errorCallback,
  });
}
/**
 *
 * @param {String} action edm_subscribe, free_invite
 */
export function getToken(action) {
  // if (window.location.port) {
  if (process.env.VUE_APP_ENV === 'development') {
    return devSecretKey;
  }
  return window.grecaptcha.enterprise.execute(siteKey, { action: action }).catch((payload) => {
    console.error('getToken error', payload);
  });
}

/**
 * get reCaptcha v2 response content
 */
export function getV2Response() {
  return window.grecaptcha.enterprise.getResponse();
}

export function getCheckboxResponse() {
  return window.grecaptcha.enterprise.getResponse();
}

/**
 * get reCaptcha v2 reset content
 */
export function resetV2() {
  return window.grecaptcha.enterprise.reset();
}

/**
 *
 */
export function getDevTokenV2() {
  return devSecretKeyV2;
}
